import { render, staticRenderFns } from "./BroadcastEdit.vue?vue&type=template&id=5902cd41"
import script from "./BroadcastEdit.vue?vue&type=script&lang=js"
export * from "./BroadcastEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports